export const SEPARATOR = '/§SEPARATOR§/';
